<script setup>
import { ref } from 'vue'
import { DmDropdownMenu, DmDropdownMenuItem, DmDropdownMenuItemGroup, DmButton, Icon } from 'dmui_components'

const props = defineProps({
	order: {
		type: Object,
		default: () => ({})
	}
})

const emit = defineEmits(['update:order'])

const options = [{ label: 'Last edited ', value: { updated_at: -1 } }]
const selectedOrder = ref(options[0])

function onSelectOrder(event) {
	selectedOrder.value = event
	emit('update:order', { ...props.order, ...event.value })
}
</script>

<template>
	<DmDropdownMenu>
		<template #button="{ onClick }">
			<DmButton id="order-button" class="transparent secondary small" @click="onClick">
				{{ selectedOrder.label }}
				<Icon name="uil-angle-down" size="midi" />
			</DmButton>
		</template>
		<template #options>
			<DmDropdownMenuItemGroup direction="right">
				<DmDropdownMenuItem v-for="{ label, value } in options" :key="label" @click="onSelectOrder({ label, value })">
					<div class="option secondary-text">{{ label }}</div>
					<Icon v-if="selectedOrder.label === label" name="uil-check" size="midi" />
				</DmDropdownMenuItem>
			</DmDropdownMenuItemGroup>
		</template>
	</DmDropdownMenu>
</template>

<style scoped lang="less">
.dm-dropdown-menu {
	margin-left: auto;
}
</style>
